<template>
  <v-container
    class="accounts-view-container"
    fluid
  >
    <h1>Accounts</h1>
    <accounts-table
      :accounts="accounts"
      :accounts-pagination="accountsPagination"
      :loading="loading"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { toQueryString } from '@/helpers';
import { AccountsTable } from '@/components/baader';

export default {
  name: 'Accounts',
  components: {
    'accounts-table': AccountsTable,
  },
  computed: {
    ...mapState({
      loading: state => state.baaderAccountsStore.loading,
      accounts: state => state.baaderAccountsStore.accounts,
      accountsPagination: state => state.baaderAccountsStore.accountsPagination,
    }),
  },
  async mounted() {
    this.getAccounts(toQueryString({ sort: 'created_at', dir: 'desc', page: 1, limit: 25 }));
  },
  methods: {
    ...mapActions(['getAccounts']),
  },
};
</script>


<style lang="scss" scoped>
.accounts-view-container{
  max-width: 1500px;
}
</style>



// WEBPACK FOOTER //
// src/views/baader/Accounts.vue